import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Box, Anchor, IconButton, IconChevronDownOutline } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { useDropdownBehavior } from "../../hooks/useDropdownBehavior.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
import ColumnsNav from "./ColumnsNav.esm.js";
import Dropdown from "./Dropdown.esm.js";
const MenuItem = ({
  item,
  transparent,
  sx
}) => {
  const {
    dropdown,
    setDropdown,
    ref,
    onMouseEnter,
    onMouseLeave
  } = useDropdownBehavior();
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const sendCmsAnchorEventOnClick = (item2) => {
    sendEvent("cms_anchor", item2.label, item2.url, cmsInfo);
  };
  const hasColumns = item.columns && item.columns.length > 0;
  const hasChildren = item.children && item.children.length > 0;
  if (hasColumns || hasChildren) {
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box, { as: "li", sx: {
      ...sx,
      color: transparent ? "$colors.textWhite" : "$colors.textDark",
      fontFamily: "$fonts.sansSerif",
      lineHeight: "$lineHeights.body",
      alignItems: "center",
      position: !hasColumns ? "relative" : "static",
      "@media $lg_lte": {
        borderBottom: "solid 1px $colors.borderLight",
        flexDirection: "column",
        width: "100%"
      }
    }, ref, onMouseEnter, onMouseLeave, children: [
      /* @__PURE__ */ jsxs(Box, { sx: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        "@media $xl": {
          "& > :first-child": {
            paddingRight: "$spacing.none"
          }
        },
        "@media $lg_lte": {
          justifyContent: "space-between",
          padding: "$spacing.sm"
        }
      }, children: [
        /* @__PURE__ */ jsx(Box, { as: Anchor, href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: (e) => {
          if (item.url === "#") {
            e.preventDefault();
            setDropdown(!dropdown);
          } else {
            sendCmsAnchorEventOnClick(item);
          }
        }, "aria-haspopup": "menu", "aria-expanded": dropdown ? "true" : "false", sx: {
          display: "flex",
          alignItems: "center",
          color: transparent ? "$colors.textWhite !important" : "$colors.textDark !important",
          textDecoration: "none !important",
          ":hover, :focus": {
            color: transparent ? "$colors.textWhite" : "$colors.brand !important"
          },
          "@media $xl": {
            width: "100%",
            height: "100%",
            padding: "$spacing.xs $spacing.sm"
          },
          "@media $lg_lte": {
            flex: 1
          }
        }, children: item.label }),
        /* @__PURE__ */ jsx(Box, { as: IconButton, bare: true, size: "xs", "aria-haspopup": "menu", "aria-expanded": dropdown ? "true" : "false", "aria-label": dropdown ? `Close ${item.label} menu` : `Open ${item.label} menu`, icon: /* @__PURE__ */ jsx(IconChevronDownOutline, {}), sx: {
          "&&&:hover": {
            // Remove <IconButton> hover background
            backgroundColor: "transparent"
          }
        }, onClick: () => setDropdown(!dropdown) })
      ] }),
      hasColumns ? /* @__PURE__ */ jsx(ColumnsNav, { columns: item.columns, transparent, isVisible: dropdown, onMouseEnter, onMouseLeave }) : /* @__PURE__ */ jsx(Dropdown, { submenus: item.children, dropdown })
    ] }) });
  }
  return /* @__PURE__ */ jsx(Box, { as: "li", sx: {
    ...sx,
    color: transparent ? "$colors.textWhite" : "$colors.textDark",
    fontFamily: "$fonts.sansSerif",
    lineHeight: "$lineHeights.body",
    alignItems: "center",
    "@media $lg_lte": {
      borderBottom: "solid 1px $colors.borderLight",
      flexDirection: "column",
      width: "100%"
    },
    ":hover, :focus": {
      color: transparent ? "$colors.textWhite" : "$colors.brand !important",
      cursor: "pointer"
    }
  }, children: /* @__PURE__ */ jsx(Box, { as: Anchor, sx: {
    color: transparent ? "$colors.textWhite !important" : "$colors.textDark !important",
    padding: "$spacing.xs $spacing.sm",
    textDecoration: "none !important",
    ":visited": {
      color: transparent ? "$colors.textWhite !important" : "$colors.textDark !important"
    },
    ":hover": {
      color: transparent ? "$colors.textWhite" : "$colors.brand !important"
    },
    "@media $lg_lte": {
      padding: "$spacing.sm",
      width: "100%"
    }
  }, href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: yieldCallback(() => {
    sendCmsAnchorEventOnClick(item);
  }), children: item.label }) });
};
export {
  MenuItem as default
};
